module.exports = __webpack_public_path__ + "static/logo_guide_star_crown-63949e8e5d9a9e1b3abb54ab0b99abe8.png";